

import {Component, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';

/**
 * @title Highlight the first autocomplete option
 */
 @Component({
     selector: 'app-autocomplete',
     templateUrl: './autocomplete.component.html',
     styleUrls: ['./autocomplete.component.scss']
 })
export class AutocompleteComponent implements OnInit {
  myControl = new FormControl();
  options: string[] = ['ירושלים', 'צפת', 'תל אביב', 'חולון', 'רעננה', 'הרצליה', 'פתח תקווה', 'בני ברק', 'רמת גן', 'ראשון לציון', 'נס ציונה', 'פרדס חנה', 'קרית שמונה', 'טבריה', 'חיפה', 'הוד השרון', 'יהוד', 'אור יהודה', 'רמלה', 'לוד', 'בת ים' ];
  filteredOptions: Observable<string[]>;

  ngOnInit() {
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value))
    );
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.options.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
  }
}



